import React from 'react';

import styled from '@emotion/styled';
import { useMediaQuery } from '@react-hook/media-query';

import ArrowIcon from '../Icons/ArrowIcon';
import DangerIcon from '../Icons/DangerIcon';

interface IStyledButton {
  isActive?: boolean;
}

interface IButton {
  children: React.ReactNode;
  className?: string;
  arrowIcon?: boolean;
  onClick?: () => void;
  isActive?: boolean;
}

export const PrimaryButtonAdd: React.FC<IButton> = ({
  children,
  className,
  arrowIcon,
  onClick,
  isActive,
}) => {
  const isMobile = useMediaQuery('(max-width: 480px)');
  return (
    <StyledButton
      className={`${className ? className : ''} ${isActive ? 'active' : ''}`}
      isActive={isActive}
      onClick={onClick}
    >
      {children} {arrowIcon && !isMobile && <ArrowIcon />}{' '}
      {className?.includes('danger') && <DangerIcon />}
    </StyledButton>
  );
};

const StyledButton = styled.button<IStyledButton>`
  display: flex;
  gap: 1.25rem;
  justify-content: center;
  align-items: center;
  border: 1px solid #bdbdbd;
  color: #bdbdbd;
  text-align: center;
  border-radius: 0.375rem;
  padding: 0.5rem 1.5rem;
  background-color: transparent;
  cursor: pointer;
  font-weight: 400;

  &.active {
    border: 1px solid blue;
    color: #2857d1;
  }

  &.actives {
    color: #2857d1;
  }

  &.grey {
    border: 1px solid ${({ theme }) => theme.palette.greyGrey1};
    color: ${({ theme }) => theme.palette.greyGrey1};
  }

  &.big {
    padding: 1.25rem;
    font-size: 1.25rem;
    font-weight: 600;
    @media (max-width: 480px) {
      display: block;
      // padding: .5rem 5rem;
      width: 100%;
      padding: 0.5rem 0;
      font-size: 2rem;
      margin-top: 0rem;
    }
  }

  &.smallGap {
    gap: 0.5rem;
    @media (max-width: 480px) {
      display: flex;
      padding: 0.1rem 5rem;
      font-size: 2rem;
      margin-top: 0rem;
    }
  }

  &.contentFit {
    width: fit-content;
  }

  &.transparent {
    padding: 0.94rem 3.62rem;
    background-color: transparent;
    border-color: white;
    color: blue;
    border-radius: 0.1875rem;

    @media (max-width: 480px) {
      display: block;
      // padding: .2rem 7rem;
      font-size: 1.3rem;
      width: 100%;
      margin-top: 0rem;
    }
  }

  &.weight500 {
    font-weight: 500;
    padding: 0.94rem 5.5rem;

    @media (max-width: 480px) {
      padding: 1rem 5rem;
      font-size: 0.8rem;
      font-weight: 700;
      width: 100%;
      margin-bottom: -1rem;
    }
  }

  &.noBorder {
    border: 1px solid transparent;
    padding: 0;
    font-size: 1.125rem;
    font-weight: 500;
  }

  &.fw600 {
    font-weight: 600;
  }

  &.pl-pr-4 {
    padding-left: 4rem;
    padding-right: 4rem;
  }

  &.pl-pr-5 {
    border: none;
    padding: 0;
  }

  &.danger {
    border: 1px solid ${({ theme }) => theme.palette.stateColorRed};
    color: ${({ theme }) => theme.palette.stateColorRed};
  }
`;
